export var Route = {
  route: '',
  setRoute: function setRoute(newRoute) {
    this.route = newRoute;
  },
  getRoute: function getRoute() {
    return this.route;
  }
};